<template>
  <div class="content1">
    <div class="pc" v-if="mobileFlag">
      <div class="query_con">
        <el-form :inline="true" :model="query" class="demo-form-inline">
          <el-form-item label="起止时间">
            <el-date-picker
              v-model="query.medalDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 260px"
              @change="queryData"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              v-model="query.receiverEmpno"
              placeholder="请输入工号"
              style="width: 150px"
              clearable
              @change="queryData"
            ></el-input>
          </el-form-item>
          <el-form-item label="公益类型">
            <el-select
              v-model="query.cardType"
              placeholder="请选择公益类型"
              style="width: 150px"
              clearable
              @change="queryData"
            >
              <el-option
                v-for="item in optionsType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批状态">
            <el-select
              v-model="query.state"
              placeholder="请选择审批状态"
              style="width: 150px"
              clearable
              @change="queryState"
            >
              <el-option
                v-for="item in optionState"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批人类型">
            <el-select
              v-model="query.nameType"
              placeholder="请选择审批人类型"
              style="width: 150px"
              clearable
              @change="queryData"
            >
              <el-option label="全部" value="0"> </el-option>
              <el-option label="上级负责人" value="1"> </el-option>
              <el-option label="管理员" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="add" @click="queryParams">查询</el-button>
            <el-button class="add" @click="exportRecord">导出</el-button>
            <el-button class="add" @click="apply" v-if="isAdmin == 1"
              >管理员审核</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="table_con">
        <div class="message" style="font-size: 13px;text-align: right;margin-bottom: 10px;">
          合计公益时长:{{ duration }}小时
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="tableLoading"
          :height="windowHeight"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            min-width="60"
          >
          </el-table-column>
          <el-table-column
            prop="empName"
            label="员工姓名"
            align="center"
            min-width="100"
          >
          </el-table-column>

          <el-table-column
            prop="empNo"
            label="工号"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="departmentName"
            label="员工部门"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="pbType"
            label="个人公益类型"
            align="center"
            min-width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>
                {{ optionsType[scope.row.pbType - 1]?.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="enterTime"
            label="参加公益日期"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="blood"
            label="献血量/ml"
            align="center"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="fingertipName"
            label="公益活动"
            align="center"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="money"
            label="捐款金额/元"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="money"
            label="捐款估算价值/元"
            align="center"
            min-width="110"
          >
          </el-table-column>

          <el-table-column
            prop="hour"
            label="公益时长/h"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <!-- <el-table-column
          prop="senderEmpno"
          label="预计换算积分"
          align="center"
          min-width="100"
        >
        </el-table-column> -->
          <el-table-column
            prop="state"
            label="审批状态"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.state == 1">待审批</span>
              <span v-if="scope.row.state == 2">审批通过</span>
              <span v-if="scope.row.state == 3">审批不通过</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="auditType"
            label="审批人类型"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.auditType == 1">上级审批</span>
              <span v-if="scope.row.auditType == 2">管理员审批</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="auditName"
            label="审批人"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="reason"
            label="审批理由"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="auditTime"
            label="审批时间"
            align="center"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="image"
            label="附件材料"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.image" :key="index">
                <img
                  style="width: 80px; height: 80px"
                  :src="imgUrl + item"
                  alt=""
                  @click="previewBeforeImage(item)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            min-width="100"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_con">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageData.page"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
      <el-dialog :visible.sync="dialogVisibleImg">
        <img width="100%" :src="imgUrl + dialogImageUrl" alt="" />
      </el-dialog>
      <el-dialog :visible.sync="dialogVisibleApply" title="审批" width="30%">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="auditRemark"
        ></el-input>
        <div class="text" style="margin-top: 20px">
          驳回理由如:
          <span @click="clickText('经审核,证明材料不齐全,请及时补充更正')"
            >经审核,证明材料不齐全,请及时补充更正</span
          >
        </div>
        <span slot="footer" class="dialog-footer">
          <el-popconfirm title="确定要驳回审核吗？" @confirm="noApply">
            <el-button slot="reference" style="margin-right: 20px"
              >驳回</el-button
            >
          </el-popconfirm>
          <el-popconfirm title="确定要通过审核吗？" @confirm="submitApply">
            <el-button slot="reference" type="primary">审批通过</el-button>
          </el-popconfirm>
        </span>
      </el-dialog>
    </div>
    <div class="mobile" v-else>
      <div class="mobile_full"><personalRecordMobile /></div>
    </div>
  </div>
</template>
<script>
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
import moment from "moment";
import { redirectRoute } from "@/utils/tools";
import personalRecordMobile from "./personalRecordMobile";
export default {
  name: "badgeMaintain",
  components: {
    personalRecordMobile,
  },
  data() {
    return {
      query: {
        cardType: "",
        receiverEmpno: "",
        senderEmpno: "",
        state: 1,
        medalDate: [],
        nameType: "2",
      },
      pageData: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      dialogVisibleImg: false,
      dialogImageUrl: "",
      windowHeight: 350,
      isShowRecord: 1,
      optionsType: [],
      optionState: [
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "审核通过",
          value: 2,
        },
        {
          label: "审核不通过",
          value: 3,
        },
      ],
      imgUrl: "",
      upload: "",
      multipleSelection: [],
      isAdmin: "",
      dialogVisibleApply: false,
      auditRemark: "",
      mobileFlag: false,
      duration:0
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.queryType();
    this.redirect();
    this.getDuration()
    setTimeout(() => {
      this.getIsAdmin();
    }, 700);
  },
  // 组件销毁时移除事件监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //获取公益时长
    getDuration(){
      apis.duration().then(res => {
        console.log(res, "duration");
        this.duration = res.data
      })
    },
    //判断是否是移动端
    redirect() {
      const { type } = this.$route.query;
      const flag = redirectRoute();
      if (type && !flag) {
        this.mobileFlag = false;
      } else {
        this.mobileFlag = true;
      }
      console.log(this.mobileFlag, "this.mobileFlag");
    },
    // 驳回
    clickText(val) {
      this.auditRemark = val;
    },
    //·获取管理员权限
    getIsAdmin() {
      apis
        .isAdmin({
          empNo: this.$store.state.userInfo.username,
        })
        .then((res) => {
          console.log(res, "res");
          this.isAdmin = res.data.isAdmin;
        });
    },
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 320;
      });
    },
    queryParams() {
      this.queryData();
    },

    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页数
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },
    queryState() {
      this.queryData();
    },
    // 审批通过
    submitApply() {
      const params = {
        id: this.multipleSelection[0].id,
        auditNo: this.$store.state.userInfo.username,
        state: 2,
      };
      apis.adminAudit(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "审批通过成功",
            type: "success",
          });
          this.queryData();
          this.dialogVisibleApply = false;
        }
      });
    },
    // 审批驳回
    noApply() {
      const params = {
        id: this.multipleSelection[0].id,
        auditNo: this.$store.state.userInfo.username,
        state: 3,
        reason: this.auditRemark,
      };
      apis.adminAudit(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "审批驳回成功",
            type: "success",
          });
          this.queryData();
          this.dialogVisibleApply = false;
        }
      });
    },
    // 管理员审批
    apply() {
      if (this.multipleSelection.length == 1) {
        this.dialogVisibleApply = true;
        this.auditRemark = "";
      } else {
        this.$message({
          type: "error",
          message: "请选择一条数据",
        });
      }

      // if (this.multipleSelection.length == 1) {
      //   this.$confirm(``, `审核`, {
      //     confirmButtonText: "审批通过",
      //     cancelButtonText: "驳回",
      //     distinguishCancelAndClose: true, // 启用按钮区分
      //   })
      //     .then(() => {
      //       const params = {
      //         id: this.multipleSelection[0].id,
      //         auditNo: this.$store.state.userInfo.username,
      //         state: 2,
      //       };
      //       apis.adminAudit(params).then((res) => {
      //         if (res.code == 200) {
      //           this.$message({
      //             message: "审批通过成功",
      //             type: "success",
      //           });
      //           this.queryData();
      //         }
      //       });
      //     })
      //     .catch((action) => {
      //       console.log(action,'action');

      //       if (action === "cancel") {
      //         // 用户点击驳回按钮
      //         const params = {
      //           id: this.multipleSelection[0].id,
      //           auditNo: this.$store.state.userInfo.username,
      //           state: 3,
      //         };
      //         apis.adminAudit(params).then((res) => {
      //           if (res.code == 200) {
      //             this.$message({
      //               message: "审批驳回成功",
      //               type: "success",
      //             });
      //             this.queryData();
      //           }
      //         });
      //       } else if (action === "close") {
      //         // 用户点击关闭按钮，不做任何处理
      //         // this.$message({
      //         //   message: "操作已取消",
      //         //   type: "info",
      //         // });
      //       }
      //     });
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "请选择一条数据",
      //   });
      // }
    },
    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData,
        empNo: this.query.receiverEmpno,
        state: this.query.state,
        typeId: this.query.cardType,
        startTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        endTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[1]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        auditType: this.query.nameType,
      };
      this.tableLoading = true;
      api
        .pubBenefitAdminPersonListListApi(json)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.tableData.forEach((item) => {
              item.signInStartTime = item.signInStartTime
                ? this.$moment(item.signInStartTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : "";
              item.signInEndTime = item.signInEndTime
                ? this.$moment(item.signInEndTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.enterTime = item.enterTime
                ? this.$moment(item.enterTime).format("YYYY-MM-DD")
                : "";
              item.updateTime = item.updateTime
                ? this.$moment(item.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.auditTime = item.auditTime
                ? this.$moment(item.auditTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.createTime = item.createTime
                ? this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.image = item.image ? item.image.split(",") : [];
            });
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 查询类型
    queryType() {
      apis.getTypeList().then((res) => {
        if (res.code == 200) {
          this.optionsType = res.data.slice(0, 5);
          // this.optionsType.unshift({
          //   key: "",
          //   value: "全部"
          // });
        }
      });
    },
    // 导出
    exportRecord() {
      const json = {
        empNo: this.query.receiverEmpno,
        state: this.query.state,
        typeId: this.query.cardType,
        startTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        endTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[1]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        auditType: this.query.nameType,
      };
      api.adminPersonListExport(json).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `个人提报记录.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    // 图片放大预览
    previewBeforeImage(item) {
      this.dialogImageUrl = item;
      this.dialogVisibleImg = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.content1 {
  background-color: #f2fcf9;

  .mobile {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: #f0f2f5;
    display: flex;
    justify-content: center;
    font-size: 11px * $zoom;
    @media screen and (max-width: 600px) {
      .mobile_full {
        width: 100%;
        background: url("~@/assets/newMedal/bg2.png");
        background-size: 100% 100%;
      }
    }
    @media screen and (min-width: 600px) {
      .mobile_full {
        width: 276px * $zoom;
        background: url("~@/assets/newMedal/bg2.png");
        background-size: 100% 100%;
      }
    }
  }

  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 20px 20px 40px;
    margin: 0 40px;
    border-radius: 5px;
    ::v-deep {
      thead {
        tr {
          th:nth-child(7),
          th:nth-child(8),
          th:nth-child(9),
          th:nth-child(10) {
            background: #a4dcdc !important;
          }
        }
      }
    }
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
</style>
